import { gql } from "@shopify/hydrogen";

export const MEDIA_FRAGMENT = gql`
  fragment Media on Media {
    mediaContentType
    alt
    previewImage {
      url
    }
    ... on MediaImage {
      id
      image {
        url
        width
        height
      }
    }
    ... on Video {
      id
      sources {
        mimeType
        url
      }
    }
    ... on Model3d {
      id
      sources {
        mimeType
        url
      }
    }
    ... on ExternalVideo {
      id
      embedUrl
      host
    }
  }
`;

export const PRODUCT_CARD_FRAGMENT = gql`
  fragment ProductCard on Product {
    id
    title
    publishedAt
    handle
    featuredImage {
      url
      width
      height
      altText
    }
    customField: metafield(namespace: "attributes", key: "customField") {
      value
    }
    variants(first: 1) {
      nodes {
        id
        image {
          url
          altText
          width
          height
        }
      }
    }
  }
`;

export const ALL_COLLECTIONS_FRAGMENT = gql`
    collections(first: 250, after: $cursor) {
      nodes {
        title
        id
        handle
        image {
          id
          url
          altText
          width
          height
        }
        collectionType: metafield(namespace: "attributes", key: "collectionType") {
          value
        }
        categoryLevel: metafield(namespace: "attributes", key: "categoryLevel"){
          value
        }
        showInHome: metafield(namespace: "attributes", key: "showInHome"){
          value
        }
        enabled: metafield(namespace: "attributes", key: "enabled"){
          value
        }
        collectionPosition: metafield(namespace: "Order", key: "collectionPosition"){
          value
        }
        subCategories: metafield(namespace: "attributes", key: "subCategories"){
          value
        }
        landscape: metafield(namespace: "attributes", key: "landscape"){
          value
        }
        cheaperPrice: metafield(namespace: "retailSystem", key: "cheaperPrice"){
          value
        }
        enableInteractiveCategoryList: metafield(namespace: "attributes", key: "EnableInteractiveCategoryList"){
          value
        }
        hasGrandchildren: metafield(namespace: "attributes", key: "hasGrandchildren"){
          value
        }
        customField: metafield(namespace: "attributes", key: "customField"){
          value
        } 
        productRanges: metafield(namespace: "attributes", key: "productranges"){
            value
        } 
        landscape: metafield(namespace: "attributes", key: "landscape"){
          value
        } 
        portrait: metafield(namespace: "attributes", key: "portrait"){
          value
        } 
        square: metafield(namespace: "attributes", key: "square"){
          value
        } 
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
`;
export const ALL_COLLECTIONS_CUSTOM_FRAGMENT = gql`
    collections(first: 250, after: $cursor, query: "collection_type:custom") {
      edges {
        node {
          title
          id
          handle
          image {
            id
            url
            altText
            width
            height
          }
          collectionType: metafield(namespace: "attributes", key: "collectionType") {
            value
          }
          categoryLevel: metafield(namespace: "attributes", key: "categoryLevel"){
            value
          }
          showInHome: metafield(namespace: "attributes", key: "showInHome"){
            value
          }
          enabled: metafield(namespace: "attributes", key: "enabled"){
            value
          }
          collectionPosition: metafield(namespace: "Order", key: "collectionPosition"){
            value
          }
          subCategories: metafield(namespace: "attributes", key: "subCategories"){
            value
          }
          landscape: metafield(namespace: "attributes", key: "landscape"){
            value
          }
          cheaperPrice: metafield(namespace: "retailSystem", key: "cheaperPrice"){
            value
          }
          enableInteractiveCategoryList: metafield(namespace: "attributes", key: "EnableInteractiveCategoryList"){
            value
          }
          hasGrandchildren: metafield(namespace: "attributes", key: "hasGrandchildren"){
            value
          }
          customField: metafield(namespace: "attributes", key: "customField"){
            value
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
`;

export const COLLECTION_BY_HANDLE_FRAGMENT = gql`
    collection(handle: $handle) {
      title
      id
      handle
      descriptionHtml
      image {
        id
        url
        altText
        width
        height
      }
      collectionType: metafield(namespace: "attributes", key: "collectionType") {
        value
      }
      categoryLevel: metafield(namespace: "attributes", key: "categoryLevel"){
        value
      }
      showInHome: metafield(namespace: "attributes", key: "showInHome"){
        value
      }
      enabled: metafield(namespace: "attributes", key: "enabled"){
        value
      }
      collectionPosition: metafield(namespace: "Order", key: "collectionPosition"){
        value
      }
      subCategories: metafield(namespace: "attributes", key: "subCategories"){
        value
      }
      cheaperPrice: metafield(namespace: "retailSystem", key: "cheaperPrice"){
        value
      }
      customField: metafield(namespace: "attributes", key: "customField"){
        value
      }
      enableInteractiveCategoryList: metafield(namespace: "attributes", key: "EnableInteractiveCategoryList"){
        value
      }
      hasGrandchildren: metafield(namespace: "attributes", key: "hasGrandchildren"){
        value
      }
      productRanges: metafield(namespace: "attributes", key: "productranges"){
        value
      }
      landscape: metafield(namespace: "attributes", key: "landscape"){
        value
      }
      square: metafield(namespace: "attributes", key: "square"){
        value
      }
      portrait: metafield(namespace: "attributes", key: "portrait"){
        value
      }
      subCategoriesJson: metafield(namespace: "attributes", key: "subCategoriesJson"){
        value
      } 
    }
`;

export const COLLECTION_BY_HANDLE = gql`
    collectionbyhandle(handle: $handle) {
      title
      id
      handle
      descriptionHtml
      image {
        id
        url
        altText
        width
        height
      }
      collectionType: metafield(namespace: "attributes", key: "collectionType") {
        value
      }
      subCategories: metafield(namespace: "attributes", key: "subCategories"){
        value
      }
      enableInteractiveCategoryList: metafield(namespace: "attributes", key: "EnableInteractiveCategoryList"){
        value
      }
    }
`;

export const PRODUCT_BY_HANDLE_FRAGMENT = gql`
  product(handle: $handle) {
    compareAtPriceRange {
        maxVariantPrice {
          currencyCode
          amount
        }
        minVariantPrice {
          currencyCode
          amount
        }
      }
      description
      descriptionHtml
      featuredImage {
        url
        width
        height
        altText
      }
      handle
      id
      media(first: 6) {
        edges {
          node {
            ... on MediaImage {
              mediaContentType
              image {
                id
                url
                altText
                width
                height
              }
            }
            ... on Video {
              mediaContentType
              id
              previewImage {
                url
              }
              sources {
                mimeType
                url
              }
            }
            ... on ExternalVideo {
              mediaContentType
              id
              embedUrl
              host
            }
            ... on Model3d {
              mediaContentType
              id
              alt
              mediaContentType
              previewImage {
                url
              }
              sources {
                url
              }
            }
          }
        }
      }
      customizeOptions: metafield(namespace: "attributes", key: "customizeOptions"){
        value
      }
      customField: metafield(namespace: "attributes", key: "customField"){
        value
      }
      priceRange: metafield(namespace: "attributes", key: "priceRange"){
        value
      }
      images: metafield(namespace: "attributes", key: "images"){
        value
      }
      descriptionBelowButton: metafield(namespace: "attributes", key: "descriptionBelowButton"){
        value
      }
      minimumQuantity: metafield(namespace: "attributes", key: "minimumQuantity"){
        value
      }
      multiplierQuantity: metafield(namespace: "attributes", key: "multiplierQuantity"){
        value
      }
      callouts: metafield(namespace: "attributes", key: "callouts"){
        value
      }
      bodyHtmlTabs: metafield(namespace: "attributes", key: "bodyHtmlTabs"){
        value
      } 
      redirectUrl: metafield(namespace: "attributes", key: "redirect"){
        value
      }
      # priceRange {
      #   maxVariantPrice {
      #     currencyCode
      #     amount
      #   }
      #   minVariantPrice {
      #     currencyCode
      #     amount
      #   }
      # }
      seo {
        description
        title
      }
      title
      variants(first: 250) {
        edges {
          node {
            availableForSale
            basePriceOptions: metafield(namespace: "stock", key: "basePriceOptions"){
              value
            }
            options: metafield(namespace: "stock", key: "options"){
              value
            }
            addOnOptions: metafield(namespace: "stock", key: "addOnOptions"){
              value
            }
            oldPrices: metafield(namespace: "properties", key: "oldPrices"){
              value
            }
            showInProductPage: metafield(namespace: "properties", key: "showInProductPage"){
              value
            }
            id
            quantityAvailable
            price {
              amount
              currencyCode
            }
            image {
              id
              url
              altText
              width
              height
              
            }
            selectedOptions {
              name
              value
            }
            sku
            title
            unitPrice {
              amount
              currencyCode
            }
            unitPriceMeasurement {
              measuredType
              quantityUnit
              quantityValue
              referenceUnit
              referenceValue
            }
            showInProductPage: metafield(namespace: "properties", key: "showInProductPage"){
              value
            }
          }
        }
      }
      vendor
      productType
    }
`;
